<ng-container *ngIf="$adressInfo | async as addressInfo">
  <iframe frameborder="0"
          [src]="getUrl(addressInfo)"
  ></iframe>
</ng-container>



